<nav class="side-bar-double">
  <div class="side-bar-double__header">


    <a routerLink="/" class="main-logo">
      <svg width="64" height="73" viewBox="0 0 64 73" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M34.4666 54.8763C35.7265 56.402 37.0852 57.8593 38.5273 59.2331C45.275 65.6468 53.9202 70.254 63.5673 72.2123V66.4514C55.5521 64.5918 48.3718 60.6525 42.7019 55.2634C40.8423 53.4949 39.1421 51.567 37.6317 49.5101L34.4666 54.8763Z"
              fill="#E22B36"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M13.5431 48.8797C19.8581 42.8759 23.7822 34.5874 23.7822 25.4792V0.256989H29.6874V25.4792C29.6874 29.9118 30.4312 35.1111 31.7823 39.1415C33.1409 35.1111 33.8772 29.9118 33.8772 25.4792V0.256989H39.7823V25.4792C39.7823 34.5874 43.7065 42.8683 50.0215 48.8797C53.7938 52.4622 58.4086 55.2327 63.5624 56.8873V62.7697C56.7843 60.9405 50.7046 57.4718 45.8469 52.8493C42.196 49.373 39.2283 45.2516 37.1637 40.6823C35.6229 44.6444 33.9227 48.3939 31.7975 51.2478L31.7823 51.2706L31.7671 51.2478C29.6419 48.3939 27.9417 44.6368 26.4008 40.6823C24.3363 45.2516 21.3686 49.3806 17.7177 52.8493C12.86 57.4718 6.78023 60.9405 0.00219727 62.7697V56.8873C5.14834 55.2327 9.77076 52.4622 13.5431 48.8797Z"
              fill="#E22B36"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M49.2286 24.955C49.2286 31.5888 52.0826 37.6306 56.6898 42.0025C58.686 43.9001 61.001 45.4788 63.5589 46.6705V52.7882C59.3767 51.2777 55.6196 48.9324 52.5152 45.9798C46.8453 40.5907 43.3235 33.1448 43.3235 24.955V19.2699H49.2286V24.955Z"
              fill="#E22B36"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.3303 19.2699H20.2354V24.955C20.2354 33.1448 16.7136 40.5832 11.0437 45.9798C7.93174 48.9399 4.1746 51.2777 0 52.7882V46.6705C2.55789 45.4788 4.8729 43.9001 6.86911 42.0025C11.4688 37.623 14.3303 31.5888 14.3303 24.955V19.2699Z"
              fill="#E22B36"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M25.9356 49.5101C24.4252 51.567 22.7326 53.4949 20.8654 55.2634C15.1955 60.6449 8.01523 64.5918 0 66.4514V72.2123C9.64712 70.254 18.2923 65.6468 25.04 59.2331C26.4821 57.8593 27.8408 56.4095 29.1008 54.8763L25.9356 49.5101Z"
              fill="#E22B36"/>
      </svg>
      <h1>Сервис оценки эффективности деятельности подведомственных учреждений Москомспорта</h1>
    </a>

    <div [ngClass]="['flex-component', opened ? 'flex-component__opened' : 'flex-component__closed']">
      <button mat-icon-button (click)="toggleEmit()">
        <mat-icon>menu</mat-icon>
      </button>
      <span>
    @if (opened) {
      @if (!user.isEmpty) {
        <span>{{ user.value.lastName ? user.value.lastName : '' }} </span>
        <span>{{ user.value.firstName ? user.value.firstName.slice(0, 1).toUpperCase() + '.' : '' }} </span>
        <span>{{ user.value.middleName ? user.value.middleName.slice(0, 1).toUpperCase() + '.' : '' }}</span>
      } @else {
        <mat-progress-spinner mode="indeterminate" class="loader" diameter="24"/>
      }
    }
    </span>
      <a routerLink="/logout">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_0_176" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_0_176)">
            <path
              d="M20.15 13H8V11H20.15L18.6 9.45L20 8L24 12L20 16L18.6 14.55L20.15 13ZM15 9V5H5V19H15V15H17V19C17 19.55 16.8042 20.0208 16.4125 20.4125C16.0208 20.8042 15.55 21 15 21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H15C15.55 3 16.0208 3.19583 16.4125 3.5875C16.8042 3.97917 17 4.45 17 5V9H15Z"
              fill="#1C1B1F"/>
          </g>
        </svg>
      </a>
    </div>

    @if (titleCreate && showCreateButton && canCreate) {
      <a class="btn btn-red" (click)="createNew.emit()"><span>{{ titleCreate }}</span>
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             [matTooltip]="titleCreate" matTooltipPosition="right">
          <mask id="mask0_73_1701" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25"
                height="24">
            <rect x="0.462891" width="24" height="24" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_73_1701)">
            <path
              d="M2.46289 24V20H22.4629V24H2.46289ZM6.46289 16H7.86289L15.6629 8.225L14.2379 6.8L6.46289 14.6V16ZM4.46289 18V13.75L15.6629 2.575C15.8462 2.39167 16.0587 2.25 16.3004 2.15C16.5421 2.05 16.7962 2 17.0629 2C17.3296 2 17.5879 2.05 17.8379 2.15C18.0879 2.25 18.3129 2.4 18.5129 2.6L19.8879 4C20.0879 4.18333 20.2337 4.4 20.3254 4.65C20.4171 4.9 20.4629 5.15833 20.4629 5.425C20.4629 5.675 20.4171 5.92083 20.3254 6.1625C20.2337 6.40417 20.0879 6.625 19.8879 6.825L8.71289 18H4.46289Z"
              fill="#1C1B1F"/>
          </g>
        </svg>
      </a>
    }

    <a *ngIf="isShowReestButton" class="btn btn-grey register" routerLink="/grade"><span>Реестр оценок</span>
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
           matTooltip="Реестр оценок" matTooltipPosition="right">
        <mask id="mask0_69_1677" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
          <rect x="0.462891" width="24" height="24" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_69_1677)">
          <path
            d="M12.463 22.025C12.1963 22.025 11.9422 21.975 11.7005 21.875C11.4588 21.775 11.238 21.6333 11.038 21.45L3.01299 13.425C2.82965 13.225 2.68799 13.0042 2.58799 12.7625C2.48799 12.5208 2.43799 12.2667 2.43799 12C2.43799 11.7333 2.48799 11.475 2.58799 11.225C2.68799 10.975 2.82965 10.7583 3.01299 10.575L11.038 2.55001C11.238 2.35001 11.4588 2.20417 11.7005 2.11251C11.9422 2.02084 12.1963 1.97501 12.463 1.97501C12.7297 1.97501 12.988 2.02084 13.238 2.11251C13.488 2.20417 13.7047 2.35001 13.888 2.55001L21.913 10.575C22.113 10.7583 22.2588 10.975 22.3505 11.225C22.4422 11.475 22.488 11.7333 22.488 12C22.488 12.2667 22.4422 12.5208 22.3505 12.7625C22.2588 13.0042 22.113 13.225 21.913 13.425L13.888 21.45C13.7047 21.6333 13.488 21.775 13.238 21.875C12.988 21.975 12.7297 22.025 12.463 22.025ZM12.463 20.025L20.488 12L12.463 3.97501L4.43799 12L12.463 20.025ZM11.463 13H13.463V7.00001H11.463V13ZM12.463 16C12.7463 16 12.9838 15.9042 13.1755 15.7125C13.3672 15.5208 13.463 15.2833 13.463 15C13.463 14.7167 13.3672 14.4792 13.1755 14.2875C12.9838 14.0958 12.7463 14 12.463 14C12.1797 14 11.9422 14.0958 11.7505 14.2875C11.5588 14.4792 11.463 14.7167 11.463 15C11.463 15.2833 11.5588 15.5208 11.7505 15.7125C11.9422 15.9042 12.1797 16 12.463 16Z"
            fill="#E22B36"/>
        </g>
      </svg>
    </a>
  </div>
  <div class="side-bar-double__body">

    <h2>Справочники</h2>

    <ul pasLiCounter>
      @for (i of menuData.list; track i.name) {
        <li [pasAccessitem]="i.access">
          <a [routerLink]="['/',i.href]" >
            <mat-icon [svgIcon]=i.href></mat-icon>
            <span>{{ i.name | capitalize }}</span></a>
        </li>
      }
    </ul>
    <br/>
    <h2>Аналитика и отчетность</h2>
    <ul pasLiCounter>
      @for (i of menuData.reports; track i.name) {
        <li [pasAccessitem]="i.access">
          <a [routerLink]="['/',i.href]">
            <mat-icon [svgIcon]=i.href></mat-icon>
            <span>{{ i.name | capitalize }}</span></a>
        </li>
      }
    </ul>
    <br/>
    <h2>Администрирование</h2>
    <ul pasLiCounter>
      @for (i of menuData.admin; track i.name) {
        <li [pasAccessitem]="i.access">
          <a [routerLink]="['/',i.href]">
            <mat-icon [svgIcon]=i.href></mat-icon>
            <span>{{ i.name | capitalize }}</span></a>
        </li>
      }
    </ul>


  </div>
</nav>
